exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1ox6v{padding:32px}._3jO-T{margin:0 auto;padding:0;max-width:380px}._1E2ZN{max-width:450px}._1U2Ie{padding:20px}._3kp1D{position:relative;z-index:1;display:block;margin:12px 0;width:100%;color:#767676;text-align:center;font-size:14px}._3kp1D:before{position:absolute;top:50%;left:50%;z-index:-1;margin-top:-5px;margin-left:-20px;width:40px;height:10px;background-color:#fff;content:\"\"}._3kp1D:after{position:absolute;top:49%;z-index:-2;display:block;width:100%;border-bottom:1px solid #ddd;content:\"\"}._3bQDP{color:#484848;font-size:16px;padding-top:12px;padding-bottom:12px;border-bottom:1px solid #dce0e0;background:#edefed}._3D2zw{margin-bottom:6px}._1_-J8{overflow:hidden}._2CKzt{padding:0}.CidfZ{text-align:right}._21SkV{text-align:left}._1Y62f{color:#008489}._24jfk{font-size:16px;line-height:32px}._1Y62f:focus,._1Y62f:hover{color:#008489;text-decoration:underline}.IWoQ5{display:block;box-sizing:border-box;margin:0;padding:20px 16px;width:100%;outline:0;border:1px solid #373277;border-radius:4px;background:#373277;color:#fff;text-align:center;text-decoration:none;font-size:16px;line-height:1.3333333;cursor:pointer}._2Lmh1{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}._2Lmh1:focus,._2Lmh1:hover{border-color:#ff7e82;background-color:#ff7e82;color:#fff}.M4GsG{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}.M4GsG:focus,.M4GsG:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}._2Meck{padding:5px 0}@media screen and (max-width:640px){._1E2ZN{margin:0 auto}}", ""]);

// exports
exports.locals = {
	"root": "_1ox6v",
	"container": "_3jO-T",
	"logInModalContainer": "_1E2ZN",
	"logInModalBody": "_1U2Ie",
	"lineThrough": "_3kp1D",
	"panelHeader": "_3bQDP",
	"formGroup": "_3D2zw",
	"formSection": "_1_-J8",
	"noPadding": "_2CKzt",
	"textAlignRight": "CidfZ",
	"textAlignLeft": "_21SkV",
	"modalCaptionLink": "_1Y62f",
	"modalCaptionLinkLarge": "_24jfk",
	"button": "IWoQ5",
	"btnPrimary": "_2Lmh1",
	"btnPrimaryBorder": "M4GsG",
	"btnSmall": "_2Meck"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/ReportUserModal/ReportUserModal.css
// module id = 2559
// module chunks = 15